import { walletApi } from '.';

export async function fetchNativeCurrencies() {
	return (await walletApi).fetchUserNativeCurrencyLedgers().then(res => res.data);
}
